<template>
	<div class="submitresult">
    <Scroller :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              @on-refresh="onRefresh"
              @on-infinite="onInfinite"
              class="my_scroller"
              ref="my_scroller"

    >
      <header>
        <div class="box"></div>
        <div class="text">
          <img src="/static/images/newproducttrial/new_product-icon-submitted_successfully@2x.png">
          <p class="f18">恭喜您已提交成功</p>
        </div>
      </header>
      <div class="list">
        <div class="listitem" v-for="(item, index) of list">
          <new-product-item :productItem="item"></new-product-item>
        </div>
      </div>
    </Scroller>
    <van-overlay :show="qrcodeurl" v-if="qrcodeurl" z-index="99999">
      <div class="wrapper">
        <div class="block">
          <img :src="qrcodeurl" />
          <van-icon @click="qrcodeurl = ''" name="close" size="0.3rem" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import newProductItem from '../common/newProductItem'
import Scroller from '../common/Scroller'
export default {
  name: 'submitresult',
  components: {
    newProductItem,
    Scroller
  },
  data () {
    return {
      refresh: false,
      loading: false,
      finished: false,
      list: [],
      nowPage: 0,
      qrcodeurl: ''
    }
  },
  methods: {
    getData () {
      var url = 'Wxmall/NewItem/getActivitylist'
      url= url + '?pageNo=' + this.nowPage + '&pageSize=' + this.pagesize
      this.$customRequestAjax(url)
        .then((res) => {
          if (res.data.code == 200) {
            if (this.nowPage == 1) {
              this.qrcodeurl = res.data.qrcodeurl
              this.list = res.data.list
              this.refresh = false
            } else {
              this.list = this.list .concat(res.data.list)
            }
            if (res.data.list.length < this.pagesize) {
              this.finished = true
            } else {
              this.finished = false
            }
          }
        })
    },
    onRefresh () {
      this.refresh = true
      this.nowPage = 1
      this.getData()
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      var that = this
      that.nowPage++
      that.getData()
    }
  }
}
</script>

<style scoped lang="scss">
  .submitresult {
    header {
      position: relative;
      width: 100%;
      overflow: hidden;
      .box {
        height: 2.4rem;
        width: 130%;
        margin-left: -15%;
        background: linear-gradient(180deg, #FB0F32 0%, #F73B63 100%);
        border-radius: 0 0 2rem 2rem;
      }
      .text {
        width: 100%;
        position: absolute;
        left: 0;
        top: 0.46rem;
        text-align: center;
        img {
          width: 0.4rem;
          height: 0.4rem;
          margin: auto;
        }
        p {
          color: #ffffff;
          margin-top: 0.1rem;
          font-family: TsangerYuYangT-W04, TsangerYuYangT;
        }
      }
    }
    .list {
      position: relative;
      margin: -1.13rem 0.11rem 0.1rem;
      .listitem {
        margin-top: 0.1rem;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/newproducttrial/submitresult.vue